import { render, staticRenderFns } from "./physical-shops.vue?vue&type=template&id=22b53102&"
import script from "./physical-shops.vue?vue&type=script&lang=js&"
export * from "./physical-shops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports